'use client';

import * as LabelPrimitive from '@radix-ui/react-label';

export const Label = LabelPrimitive.Root;

Label.displayName = 'Label';
